import { NextSeo } from 'next-seo'
import getSeo from '../../utils/seo'
import { publicSiteUrl } from '../../constants'
import PublicFolderContent from '../../components/public'
import NoSsr from '../../components/NoSsr'

import NotFoundPage from '../../components/public/FolderNotFound'

function PublicFolder({ folderAndCount, error, message }) {
  if (error) {
    // Toast({
    //   title: message || 'Error loading folder',
    //   duration: 3000,
    //   status: 'error',
    //   isClosable: true,
    //   position: 'top-right',
    // })

    return <NotFoundPage message={message} />
  }

  const { folder } = folderAndCount
  return (
    <>
      <NextSeo
        {...getSeo({
          title: `${folderAndCount?.folder?.icon ? folderAndCount?.folder.icon?.metadata?.native : '📁'}${
            folderAndCount?.folder?.name
          }`,
          description: folderAndCount?.folder?.description || `Public folder`,
        })}
      />

      <NoSsr>
        <PublicFolderContent userId={folder.user._id} folderId={folder._id} folderAndCount={folderAndCount} />
      </NoSsr>
    </>
  )
}

export async function getServerSideProps({ params }) {
  const { name } = params
  const res = await fetch(`${publicSiteUrl}/api/public/folders/${name}`)
  const data = await res.json()

  if (!res.ok) {
    return { props: { error: true, message: data.message } }
  }

  return {
    props: {
      folderAndCount: data,
    },
  }
}

export default PublicFolder
